<template>
  <FormInput :dati='info'
               :formlabel="label"
               :stilestruttura="style"
               :idform="idform"
               :action="action"
               :recaptcha="recaptcha"
               @selectChanged="aggiornaDipendenti"
               ref="input"> 
    </FormInput>

	<div class="text-right form-actions">
		<a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary form-btn-cancel"
			 :href="cancel"><i class="pi pi-times"></i><span class="p-button-label">{{ bottoneannulla }}</span></a>
		<button @click="$refs.input.checkForm(0)" class="p-button p-component p-button-success form-btn-submit">
			<i class="pi pi-send"></i>
			<span class="p-button-label">{{ bottonesalva }}</span>
		</button>
		<template v-if="bottonesalvacontinua !== ''">
			<button @click="$refs.input.checkForm(1)"
							class="p-button p-component p-button-secondary form-btn-continue">
				<span class="p-button-label">{{ bottonesalvacontinua }}</span>
			</button>
		</template>
	</div>
</template>

<script>

import FormInput from './FormInput.vue';

export default {
  name: "UpdateInfoThreadForm",
  components: {
    FormInput,
  },
  props: [
    'dati',
    'struttura',
    'azione',
    'annulla',
    'stilestruttura',
    'id',
    'recaptcha',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla'
  ],
  data() {
    return {
      cancel: this.annulla,
      action: this.azione,
      info: JSON.parse(this.dati),
      label: JSON.parse(this.struttura),
      style: this.stilestruttura,
      errors: {},
      imginput: false,
      idform: this.id,
    };
  },
  beforeMount() {
    if (typeof this.id == "undefined") {
      this.idform = 'maschera';
    } else {
      this.idform = this.id;
    }

  },
  mounted() {
    document.addEventListener('formChanged', function(e){
      this.label = e.detail.newStruttura;
    });

  },
  methods: {
    aggiornaDipendenti(){
      this.info['ticketingutentiteam_id'] =  [];
    }
  }
}
</script>

<style scoped>

</style>
